import { formatRcaStatusForDisplay } from "./rcaUtils";

export const ADD_RCA_TEST_SAMPLES_SOURCE = "test_in_samples";

/** Same query shape previously used for report_delay Add RCA. */
export const buildAddRcaTestSamplesParams = (filterState = {}, defaultDateRange) => {
  const params = {
    source: ADD_RCA_TEST_SAMPLES_SOURCE,
    date_range: filterState.date_range || defaultDateRange,
  };
  const search = String(filterState.search ?? "").trim();
  if (search !== "") {
    params.search = search;
  }
  const categoryId = filterState.test_category_id;
  if (categoryId !== null && categoryId !== undefined && categoryId !== "") {
    params.test_category_id = categoryId;
  }
  return params;
};

export const extractRcaTestSamplesList = (apiResponse = {}) => {
  if (Array.isArray(apiResponse.result)) {
    return apiResponse.result;
  }
  if (Array.isArray(apiResponse.results)) {
    return apiResponse.results;
  }
  return [];
};

/** rca_status null → Add; 1–5 → Edit. */
export const isAddRcaTestSampleExisting = (row) => {
  if (!row || typeof row !== "object") {
    return false;
  }
  const status = row.rca_status;
  if (status == null || status === "") {
    return false;
  }
  const numeric = Number(status);
  return numeric >= 1 && numeric <= 5;
};

/** Add RCA / analytics tables: only statuses 1–5 get labels; otherwise "-". */
export const formatAddRcaTableRcaStatus = formatRcaStatusForDisplay;

export const mapRcaTestSampleRow = (row = {}) => ({
  ...row,
  test_name: row.test ?? row.test_name ?? row.analysis ?? "",
  test_category: row.test_category ?? row.category_name ?? "",
  customer_name: row.customer_name ?? row.customer_company ?? "",
  sample_id: row.sample_id ?? "",
  tests_in_sample_pk: row.tis_pk ?? row.tests_in_sample_pk,
  tis_pk: row.tis_pk ?? row.tests_in_sample_pk,
  wo_id_pk: row.wo_id_pk
    ?? row.workorder_id_pk
    ?? row.workorder_pk
    ?? row.wo_pk
    ?? row.workorder_id,
  analysis: row.test ?? row.analysis ?? row.test_name,
});

export const buildAddRcaSubmitModalSubheadingParts = (row = {}) => {
  if (!row || typeof row !== "object") {
    return [];
  }
  const parts = [];
  if (row.workorder_id != null && String(row.workorder_id).trim() !== "") {
    parts.push({ key: "wo", text: `WO ID: ${row.workorder_id}` });
  }
  if (row.genista_id != null && String(row.genista_id).trim() !== "") {
    parts.push({ key: "genista", text: `Genista ID: ${row.genista_id}` });
  }
  const customerName = row.customer_name
    ?? row.customer_company
    ?? (row.customer_id != null && String(row.customer_id).trim() !== ""
      ? String(row.customer_id)
      : "");
  if (customerName !== "") {
    parts.push({ key: "customer", text: `Customer Name: ${customerName}` });
  }
  if (row.sample_id != null && String(row.sample_id).trim() !== "") {
    parts.push({ key: "sample_id", text: `Sample ID: ${row.sample_id}` });
  }
  const testLabel = row.test_name ?? row.test ?? row.analysis;
  if (testLabel) {
    parts.push({ key: "test", text: `Test: ${testLabel}` });
  }
  const categoryLabel = row.test_category ?? row.category_name;
  if (categoryLabel) {
    parts.push({ key: "test_category", text: `Test Category: ${categoryLabel}` });
  }
  return parts;
};
